import {createContext} from "react";

const MarketsContext = createContext({
  markets: [],
  closedMarkets: [],
  txs: [],
  tokens: [],
  isLoading: {
    txs: false,
    markets: true,
    closedMarkets: true,
    tokens: false
  }
});

export default MarketsContext;
